import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { toAppError } from '@/app/core/http/error-catalog';
import { RegistryDownloadJob } from '../models/beneficiary-registry.model';

export const REGISTRY_DOWNLOAD_EMAIL_REQUIRED_ERROR =
  'No podemos generar el reporte porque tu usuario no tiene un correo registrado para enviarte el aviso.';

export interface RegistryDownloadNotice {
  tone: 'error' | 'warning' | 'success';
  title: string;
  description: string;
  persistent: boolean;
}

export function toRegistryDownloadErrorNotice(cause: unknown): RegistryDownloadNotice {
  if (cause instanceof HttpErrorResponse && cause.status === HttpStatusCode.UnprocessableEntity) {
    return {
      tone: 'warning',
      title: 'No pudimos solicitar el reporte del padrón',
      description: apiErrorMessage(cause) ?? REGISTRY_DOWNLOAD_EMAIL_REQUIRED_ERROR,
      persistent: true,
    };
  }

  const appError = toAppError(cause, 'el padrón');
  const description =
    appError.kind === 'forbidden'
      ? 'Tu usuario no está habilitado para descargar el padrón. Contacta al administrador de tu institución.'
      : appError.kind === 'rateLimited'
        ? appError.description
        : 'Ocurrió un problema al generar el archivo. Vuelve a intentarlo en unos minutos.';

  return { tone: 'error', title: 'No pudimos descargar el padrón', description, persistent: true };
}

export function toRegistryDownloadJobNotice(job: RegistryDownloadJob): RegistryDownloadNotice {
  return {
    tone: 'success',
    title: 'Estamos generando el archivo del padrón',
    description: `El archivo tiene ${job.totalRecords.toLocaleString('es-CL')} registros. Te notificaremos cuando el reporte esté listo.`,
    persistent: true,
  };
}

function apiErrorMessage(cause: HttpErrorResponse): string | undefined {
  const message = (cause.error as { error?: { message?: unknown } } | null)?.error?.message;
  return typeof message === 'string' && message.trim() ? message : undefined;
}
